import { render, staticRenderFns } from "./NotRouteModal.vue?vue&type=template&id=0af73aa4&"
import script from "./NotRouteModal.vue?vue&type=script&lang=js&"
export * from "./NotRouteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports